import { getInstance } from './instance';

const instance = getInstance();

export const getAvailableCoachSlots = ({ queryKey }) => {
  const [, { email, date, timezone }] = queryKey;
  return instance
    .get(
      `coachings/${encodeURIComponent(email)}/${encodeURIComponent(date)}/${encodeURIComponent(
        timezone,
      )}`,
    )
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
};

export const registerForSelectedSlot = ({ payload, queryKey }) => {
  const { offerCode, sessionId } = queryKey;
  return instance
    .post(`onboard/schedule-coaching?offerCode=${offerCode}&sessionId=${sessionId}`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
};

/**
 * "I booked my call — continue" on the onboarding schedule-coaching step while
 * HubSpot Meetings is off (hubspot-off-block-3 task 64). DS records that the
 * call was booked on an external calendar and returns the session on its next
 * step (digital-services task 63). Idempotent on the DS side.
 */
export const confirmExternalCoaching = ({ sessionId, offerCode }) =>
  instance
    .post('onboard/schedule-coaching/confirm-external', null, {
      params: { sessionId, offerCode },
    })
    .then((response) => response.data);

export const getCoachDetails = async ({ start, offerCode, sessionId, outputTimezone }) => {
  const params = {
    start,
    offerCode,
    sessionId,
    outputTimezone,
  };

  try {
    const response = await instance.get('onboard/schedule-coaching', { params });
    return Promise.resolve(response.data);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getNewCoach = (sessionId, offerCode) => {
  return instance
    .patch(`onboard/schedule-coaching/coach?offerCode=${offerCode}&sessionId=${sessionId}`)
    .then((response) => response.data);
};

export const getTrackingPixels = async ({ offerCode }) => {
  const params = {
    offerCode,
  };

  try {
    const response = await instance.get('tracking-pixel', { params });
    return Promise.resolve(response.data);
  } catch (error) {
    return Promise.reject(error);
  }
};
